import {Component, OnInit, ViewEncapsulation, ViewChild} from '@angular/core';
import { NgModule } from '@angular/core';
import {TranslatePipeMoudle} from "../../translate/translate.module.pipe";
import {MainPipeMoudle} from "../../pipe/main.pipe";
import {CompanyDropDownListModule} from "../../component/company-drop-down-list/company-drop-down-list.component";
import {ButtonModule} from "primeng/components/button/button";
import {ExDialogModule} from "../../component/dialog.component";
import {PaginatorModule, Paginator} from "primeng/components/paginator/paginator";
import {CompanyTreeModule} from "./company_tree";
import {SearchModule} from "../../component/search.component";
import {FormsModule} from "@angular/forms";
import {CommonModule} from "@angular/common";
import {RouterModule} from "@angular/router";
import {HttpModule} from "@angular/http";
import {BrowserModule} from "@angular/platform-browser";
import {PanelModule} from "primeng/components/panel/panel";
import {TabViewModule} from "primeng/components/tabview/tabview";
import {DataTableModule} from "primeng/components/datatable/datatable";
import {MamAdminService} from "../../service/mam_service.component";
import {DropdownModule} from "primeng/components/dropdown/dropdown";
import {SelectItem} from "primeng/components/common/api";
import {CookieService} from "angular2-cookie/services/cookies.service";
import {Logger} from "angular2-logger/core";
import {TranslateServiceForm} from "../../translate/translate.service";
import {ThirdPartyCompany} from "../../model/thirdpartycompany";

@Component({
    selector: 'officeVersion',
    templateUrl: './officeapp_version_show.html'
})
export class OfficeAppVersionShowComponent implements OnInit {

    company_items : SelectItem[];
    officeApp_list : SelectItem[];
    private company_list : ThirdPartyCompany[] = [];
    companySelected : ThirdPartyCompany;
    companyId : string;
    pageMax:number =10;
    selectedPackageName : string;
    officeAppVersionList : any;
    totalRecord : any =0;
    search : string = "";
    field : string = "";

    dateIsTrue : boolean;
    searchIDs : any = [];
    excelIsTrue : boolean;
    searchText : string;
    searchId : string;
    resetIsTrue : any = "";
    @ViewChild('pagin') pagin : Paginator;
    pagi : number = 1;

    selectedCompanyFirstPackage : string;
    constructor(private service : MamAdminService, private cookie : CookieService, private logger : Logger, private _translate : TranslateServiceForm) {
        this.companyId = cookie.get('companyId');
        this.selectedPackageName = 'all';

        this.dateIsTrue = false;
        this.excelIsTrue = true;

        this.searchIDs = [];
        this.searchIDs.push({label: '----------------', value: 'all'});
        this.searchIDs.push({label: this._translate.instant('LANG_USR_user'), value: 'name'});
        this.searchIDs.push({label: this._translate.instant('IsRegistered'), value: 'isRegistered'});
        this.searchIDs.push({label: this._translate.instant('LANG_Office_Version'), value: 'version'});

        this.searchId = 'all';
        this.searchText = '';
    }

    ngOnInit() {
        this.company_items = [];

        this.officeApp_list = [];
        this.officeApp_list.push({label: '-------------------', value: 'all'});
        this.getCompanyAdminList();
        this.getOfficeAppListByPackage(this.companyId);
        this.getOfficeVersionListByDevice('all', this.pagi, this.pageMax, '','',true);

        if(this.pagin){
            this.pagin.first=0;
        }
    }
    onChangeCompany(data) {
        console.log("onChangeCompany data :", data.value);
        if(data.value.id == '') {
            //this.visitor_list = [];
            return;
        }
        this.companySelected = data.value;
        this.getOfficeAppListByPackage(String(this.companySelected.id));
        //this.getOfficeVersionListByDevice('all', this.pagi, this.pageMax, '','',true);
    }

    getCompanyAdminList() {
        this.service.getCompanyAdminList().subscribe(
            value => {
                this.company_list = value;
            },
            error => { this.logger.error("-- error : " + error); },
            () => {
                if(this.company_list != null && this.company_list.length > 0) {
                    this.company_list.forEach(value => {
                        this.company_items.push({label : value.name , value : value});
                    })
                }
            }
        )
    }
    onChangeOfficeApp(event){
        console.log("onChangeOfficeApp data :", event.value);
        this.selectedPackageName = event.value;
        this.pagi = 1;
        //여기다가 리스트 불러오는거 작성
        this.getOfficeVersionListByDevice(this.selectedPackageName, this.pagi, this.pageMax, '','',true);
        if(this.pagin){
            this.pagin.first=0;
            this.pagin.rows=this.pageMax;
        }
        this.resetIsTrue = "true"+this.selectedPackageName;

    }

    getOfficeAppListByPackage(company_Id: string) {
        this.service.getOfficeAppListByPackage(company_Id).subscribe(
            value => {
                this.officeApp_list = [];
                this.officeAppVersionList = [];  //초기화
                if(value != null && value.length > 0){
                    this.officeApp_list.push({label: '-------------------', value: 'all'});
                    value.forEach(item => {
                       this.officeApp_list.push({label : item, value : item});
                    });
                }
            },error => { this.logger.error("-- error : " + error); }
        )
    }

    getOfficeVersionListByDevice(packageName : string, page: number, max: number, search: string, field: string, searchLike:boolean) {
        this.service.getOfficeVersionListByDevice(packageName, page, max, search, field, searchLike).subscribe(
            value=>{
                this.officeAppVersionList = value.rows;
                this.totalRecord = value.total;
                this.pagi = value.page;
                console.log(value);
            },error => { this.logger.error("-- error : " + error); }
        )
    }

    paginate(event) {
        this.pageMax = event.rows;
        this.pagi = event.page+1;
        console.log(event);
        this.getOfficeVersionListByDevice(this.selectedPackageName, this.pagi ,this.pageMax, this.searchText, this.searchId, true);
    }

    getSearchModel(event){
        this.logger.debug("event : ",event);
        //this.searchIsTrue = event.searchIsTrue;
        this.searchText = event.searchText;
        this.searchId = event.searchId;
        this.pagi = 1;
        this.getOfficeVersionListByDevice(this.selectedPackageName, this.pagi ,this.pageMax, this.searchText, this.searchId, true);
        if(this.pagin){
            this.pagin.first=0;
            this.pagin.rows=this.pageMax;
        }
    }

    excelExport(event){
        if(event){
            //엑셀 다운 진행.
            this.service.getOfficeVersionListByDeviceExcel(this.selectedPackageName, this.searchText, this.searchId);
        }
    }





}

@NgModule({
    imports: [DataTableModule,TabViewModule,PanelModule,BrowserModule,HttpModule, RouterModule,CommonModule,FormsModule,SearchModule,CompanyTreeModule,PaginatorModule,ButtonModule,ExDialogModule,CompanyDropDownListModule,MainPipeMoudle,TranslatePipeMoudle,DropdownModule],
    exports: [OfficeAppVersionShowComponent],
    declarations: [OfficeAppVersionShowComponent],
    providers: [MamAdminService],
})
export class OfficeAppVersionShowModule { }



// WEBPACK FOOTER //
// ./src/app/page/device/officeapp_version_show.ts